const tourSteps = {
  "/design-center": [
    {
      popover: {
        title: "Welcome to the Design Center",
        description: "This tour will guide you through the key features of the Design Center.",
      },
    },
    {
      element: "#create-design",
      popover: {
        title: "Create New Design",
        description: "Click here to create a brand new network design from scratch.",
        side: "bottom",
        align: "start",
      },
    },
    {
      element: "#design-from-wizard",
      popover: {
        title: "New Design from Wizard",
        description: "Use this option for guided design creation using a wizard.",
        side: "bottom",
        align: "start",
      },
    },
    {
      element: "#import-xml",
      popover: {
        title: "Import Design from XML",
        description: "Import an existing design using an XML file.",
        side: "bottom",
        align: "start",
      },
    },
    {
      element: "#import-yaml",
      popover: {
        title: "Import Design from YAML",
        description: "Import an existing design using a YAML file.",
        side: "bottom",
        align: "start",
      },
    },
    {
      element: "#criterion-netbox",
      popover: {
        title: "Criterion Netbox",
        description: "Access Netbox for IP address and inventory management.",
        side: "bottom",
        align: "start",
      },
    },
    {
      element: "#design-table",
      popover: {
        title: "My Designs Table",
        description: "This table lists all your saved designs along with their status, creator, and timestamps.",
        side: "top",
        align: "center",
      },
    },
    {
      element: "#goto-template",
      popover: {
        title: "Open Template",
        description: "Click this arrow to view or edit the full design template.",
        side: "left",
        align: "center",
      },
    },
  ],
  "/experience-center-showcases": [
    {
      popover: {
        title: "Welcome to the Showcases",
        description: "This tour will guide you through the key features of the Showcases section, where you can explore, launch, and manage your showcases.",
      },
    },
    {
      element: "#simple-tab-catalog",
      popover: {
        title: "Catalog Tab",
        description: "Explore all available showcases here — including both subscribed and unsubscribed.",
        side: "bottom",
        align: "start",
      },
    },
    {
      element: "#simple-tab-subscribed",
      popover: {
        title: "Subscribed Tab",
        description: "View only the showcases you’ve subscribed to. You can launch or schedule them here.",
        side: "bottom",
        align: "start",
      },
    },
    {
      element: "#simple-tab-active",
      popover: {
        title: "Active Tab",
        description: "See the showcases you’ve actively launched and are currently running.",
        side: "bottom",
        align: "start",
      },
    },
    {
      element: "#simple-tab-scheduled",
      popover: {
        title: "Scheduled Tab",
        description: "Review your showcases that have been scheduled to run in the future.",
        side: "bottom",
        align: "start",
      },
    },
    {
      element: "#search-bar",
      popover: {
        title: "Search Showcases",
        description: "Use this search bar to filter showcases by name or keyword.",
        side: "bottom",
        align: "start",
      },
    },
    {
      element: "#launch-action",
      popover: {
        title: "Schedule or Launch",
        description: "Use these buttons to schedule or instantly launch a sandbox.",
        side: "left",
        align: "center",
      },
    },
  ],
  "/experience-center-sandboxes": [
    {
      popover: {
        title: "Welcome to the Sandboxes",
        description: "This tour will guide you through the key features of the Sandboxes section, where you can explore, launch, and manage your sandboxes.",
      },
    },
    {
      element: "#simple-tab-catalog",
      popover: {
        title: "Catalog Tab",
        description: "Explore all available sandboxes here — including both subscribed and unsubscribed.",
        side: "bottom",
        align: "start",
      },
    },
    {
      element: "#simple-tab-subscribed",
      popover: {
        title: "Subscribed Tab",
        description: "View only the sandboxes you’ve subscribed to. You can launch or schedule them here.",
        side: "bottom",
        align: "start",
      },
    },
    {
      element: "#simple-tab-active",
      popover: {
        title: "Active Tab",
        description: "See the sandboxes you’ve actively launched and are currently running.",
        side: "bottom",
        align: "start",
      },
    },
    {
      element: "#simple-tab-inactive",
      popover: {
        title: "InActive Tab",
        description: "See the sandboxes that are suspended and archieved",
        side: "bottom",
        align: "start",
      },
    },
    {
      element: "#simple-tab-scheduled",
      popover: {
        title: "Scheduled Tab",
        description: "Review your showcases that have been scheduled to run in the future.",
        side: "bottom",
        align: "start",
      },
    },
    {
      element: "#search-bar",
      popover: {
        title: "Search Showcases",
        description: "Use this search bar to filter showcases by name or keyword.",
        side: "bottom",
        align: "start",
      },
    },
    {
      element: "#launch-action",
      popover: {
        title: "Schedule or Launch",
        description: "Use these buttons to schedule or instantly launch a sandbox.",
        side: "left",
        align: "center",
      },
    },
  ],
  "/experience-center-learnings": [
    {
      popover: {
        title: "Welcome to the Learning Center",
        description: "This tour will guide you through the core features of the Learning Center, where you can find and launch your learning labs.",
      },
    },
    {
      element: "#tab-catalog",
      popover: {
        title: "Catalog Tab",
        description: "Browse the complete list of available learning labs.",
        side: "bottom",
        align: "start",
      },
    },
    {
      element: "#tab-subscribed",
      popover: {
        title: "Subscribed Tab",
        description: "Access labs that you've already subscribed to.",
        side: "bottom",
        align: "start",
      },
    },
    {
      element: "#tab-active",
      popover: {
        title: "Active Tab",
        description: "Check labs that are currently running.",
        side: "bottom",
        align: "start",
      },
    },
    {
      element: "#tab-inactive",
      popover: {
        title: "Inactive Tab",
        description: "Review previously suspended and archieved learning labs.",
        side: "bottom",
        align: "start",
      },
    },
    {
      element: "#tab-scheduled",
      popover: {
        title: "Scheduled Tab",
        description: "See your learning labs that are scheduled for future use.",
        side: "bottom",
        align: "start",
      },
    },
    {
      element: "#search-bar",
      popover: {
        title: "Search Labs",
        description: "Use this search bar to find specific labs quickly by name or keyword.",
        side: "bottom",
        align: "start",
      },
    },
    {
      element: "#launch-action",
      popover: {
        title: "Launch or Schedule",
        description: "Click here to schedule or instantly launch your selected learning lab.",
        side: "left",
        align: "center",
      },
    },
  ],
  "/statistics": [
    {
      popover: {
        title: "Welcome to Statistics",
        description: "This page gives you a detailed overview of your usage history and time spent across various product categories.",
      },
    },
    {
      element: "#usage-history",
      popover: {
        title: "Usage History Chart",
        description: "This graph shows how many hours you've spent on different modules like Design, Sandbox, and Learning over the past 3 months.",
        side: "top",
        align: "center",
      },
    },
    {
      element: "#usage-table",
      popover: {
        title: "Detailed Usage Table",
        description: "This table displays the exact hours consumed in each category along with the date calculation started.",
        side: "top",
        align: "center",
      },
    },
  ],
};

export default tourSteps;
